export const en = {
  // Navigation
  nav: {
    dashboard: 'Dashboard',
    loans: 'Loans',
    borrowers: 'Borrowers',
    repledging: 'Re-pledging',
    profitability: 'Profitability',
    analytics: 'Analytics',
    settings: 'Settings',
    support: 'Support',
    profile: 'Profile'
  },

  // Common
  common: {
    hello: 'Hello',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    update: 'Update',
    search: 'Search',
    filter: 'Filter',
    apply: 'Apply',
    actions: 'Actions',
    loading: 'Loading',
    noData: 'No data available',
    confirmDelete: 'Confirm Delete',
    areYouSure: 'Are you sure',
    saveChanges: 'Save Changes',
    business: 'Business',
    logout: 'Logout',
    createNewLoan: 'Create New Loan',
    createRepledging: 'Create Re-pledging',
    madeWithLove: 'Made with love',
    allRightsReserved: 'All rights reserved',
    developedBy: 'Developed by',
    developedByCompany: 'Developed by Seervi Tech Labs',
    unknown: 'Unknown',
    results: 'total',
    prev: 'Prev',
    next: 'Next',
    page: 'Page',
    total: 'total',
    gallery: 'Gallery',
    camera: 'Camera',
    chooseFromGallery: 'Choose from gallery',
    takePhoto: 'Take photo',
    switchToDark: 'Dark mode',
    switchToLight: 'Light mode'
  },

  // Settings Page
  settings: {
    title: 'Settings',
    todayRates: 'Today\'s Gold Rates',
    loanSettings: 'Loan Settings',
    pledgeSettings: 'Pledge Settings',
    notifications: 'Notifications',
    language: 'Language',
    appearance: 'Appearance',
    selectTheme: 'Select Theme',
    themeDescription: 'Choose light or dark mode for the application',
    lightThemeHint: 'Bright background for daytime use',
    darkThemeHint: 'Dark background for low light',
    createLoanSetting: 'Create Loan Setting',
    createPledgeSetting: 'Create Pledge Setting',
    metal: 'Metal',
    interestRate: 'Interest Rate (% per month)',
    amount: 'Amount',
    amountRange: 'Amount Range',
    name: 'Name',
    allMetals: 'All Metals',
    gold: 'Gold',
    silver: 'Silver',
    searchPlaceholder: 'Search by metal, amount range, or interest rate...',
    noSettingsFound: 'No settings found',
    noMatchingSettings: 'No settings match your filter/search criteria',
    clickToAdd: 'Click to add one',
    loadingSettings: 'Loading settings...',
    editInterestRate: 'Edit interest rate',
    deleteSetting: 'Delete setting',
    createLoanInterestSetting: 'Create Loan Interest Setting',
    createNewPledgeSetting: 'Create New Pledge Setting',
    editLoanSetting: 'Edit Loan Setting',
    minPlaceholder: 'Min (e.g., 1000)',
    maxPlaceholder: 'Max (e.g., 10000)',
    enterName: 'Enter name',
    interestRatePlaceholder: 'e.g., 2.0',
    settingCreatedSuccess: 'Setting created successfully',
    settingUpdatedSuccess: 'Setting updated successfully',
    settingDeletedSuccess: 'Setting deleted successfully',
    createSettingBtn: 'Create Setting',
    creatingSetting: 'Creating...',
    updateBtn: 'Update',
    smsWhatsappTemplates: 'SMS / WhatsApp Templates',
    loanExpiryReminder: 'Loan Expiry Reminder',
    paymentConfirmation: 'Payment Confirmation',
    selectLanguage: 'Select Language',
    languageDescription: 'Choose your preferred language for the application',
    english: 'English',
    hindi: 'Hindi',
    marwadi: 'Marwadi',
    languageUpdated: 'Language updated successfully',
    // Today's Gold Rates
    todayRatesTitle: 'Gold & Silver Rates',
    createTodayRate: 'Add Rate',
    goldType: 'Metal Type',
    todayValue: 'Today\'s Value (₹)',
    perGramValue: 'per 10 grams',
    selectGoldType: 'Select Metal Type',
    gold24K: '24K Gold',
    goldSilver: 'Silver',
    calculatedFrom24K: 'Calculated from 24K',
    gold22K: '22K Gold',
    gold18K: '18K Gold',
    rateValue: 'Rate',
    createRateBtn: 'Add Rate',
    editRate: 'Edit Rate',
    deleteRate: 'Delete Rate',
    createNewRate: 'Add New Rate',
    editRateTitle: 'Edit Rate',
    noRatesFound: 'No rates found',
    rateCreatedSuccess: 'Rate added successfully',
    rateUpdatedSuccess: 'Rate updated successfully',
    rateDeletedSuccess: 'Rate deleted successfully'
  },

  // Dashboard
  dashboard: {
    title: 'Dashboard',
    quickValuation: 'Quick Valuation',
    quickValuationCalculator: 'Quick Valuation Calculator',
    closedLoans: 'Closed Loans',
    todayClosedLoans: 'Today Closed Loans',
    createdLoans: 'Created Loans',
    todayCreatedLoans: 'Today Created Loans',
    overdueAccounts: 'Overdue Accounts',
    activeLoans: 'Active Loans',
    inHandGold: 'In Hand Gold',
    inHandOffice: 'In-Hand (Office)',
    pledged: 'Pledged',
    pledgedGold: 'Pledged Gold',
    awaitingRelease: 'Awaiting Release',
    awaitingCollection: 'Awaiting Collection',
    interestEarned: 'Interest Earned',
    totalInterestEarned: 'Total Interest Earned',
    interestEarnedChip: 'Interest Earned (This Month)',
    lateFees: 'Late Fees',
    lateFeesCollected: 'Late Fees Collected',
    averageLoanSize: 'Average Loan Size',
    thisMonth: 'This Month',
    activeLoansSubtitle: 'Active Loans',
    expiringLoans: 'Expiring Loans',
    loansNearingExpiry: 'Loans Nearing Expiry (Next 30 Days)',
    overduePayments: 'Overdue Payments',
    recentOverduePayments: 'Recent Overdue Payments',
    collateralDashboard: 'Collateral Dashboard',
    loanId: 'Loan ID',
    customerName: 'Customer Name',
    amount: 'Amount',
    expiryDate: 'Expiry Date',
    daysOverdue: 'Days Overdue',
    viewDetails: 'View Details',
    viewAll: 'View All',
    viewLoan: 'View Loan',
    noExpiringLoans: 'No loans expiring in next 30 days',
    noExpiringLoansCaughtUp: 'Great! No loans expiring in the next 30 days. You’re all caught up.',
    noOverduePayments: 'No overdue payments',
    refresh: 'Refresh',
    purity: 'Purity',
    netWeight: 'Net Weight (grams)',
    lendingRate: 'Lending Rate (per gram)',
    maxLoanValue: 'Max Loan Value',
    maximumLoanValue: 'Maximum Loan Value',
    calculate: 'Calculate',
    close: 'Close',
    grams: 'grams',
    perGram: 'per gram',
    packets: 'Packets',
    loanValue: 'Loan Value',
    goodMorning: 'Good Morning',
    goodAfternoon: 'Good Afternoon',
    goodEvening: 'Good Evening',
    heroSubtitle: "Here's what's happening with your business today.",
    businessHealth: 'Business Health',
    healthGood: 'Good',
    healthGoodHint: "You're performing well",
    healthFair: 'Fair',
    healthFairHint: 'A few accounts need attention',
    healthAttention: 'Attention',
    healthAttentionHint: 'Overdue accounts need follow-up',
    totalActiveLoans: 'Total active loans',
    requireAttention: 'Require attention',
    customers: 'Customers',
    totalLoans: 'Total Loans',
    activeLabel: 'Active',
    vsYesterday: 'vs yesterday',
    vsLastMonth: 'vs last month',
    fromLastMonth: 'from last month'
  },

  // Login Page
  login: {
    title: 'Login',
    signIn: 'Sign In',
    signUp: 'Sign Up',
    email: 'Email',
    password: 'Password',
    firstName: 'First Name',
    lastName: 'Last Name',
    loginBtn: 'Login',
    signUpBtn: 'Sign Up',
    dontHaveAccount: "Don't have an account?",
    alreadyHaveAccount: 'Already have an account?',
    signUpHere: 'Sign up here',
    signInHere: 'Sign in here',
    welcomeBack: 'Welcome back!',
    createAccount: 'Create your account',
    modernLMS: 'Modern Loan Management System',
    comprehensiveSolution: 'Comprehensive solution for managing loans and borrowers',
    features: {
      loanManagement: 'Loan Management',
      borrowerTracking: 'Borrower Tracking',
      collateralManagement: 'Collateral Management',
      profitabilityAnalysis: 'Profitability Analysis',
      advancedAnalytics: 'Advanced Analytics',
      secureReliable: 'Secure & Reliable'
    },
    featureDescriptions: {
      loanManagement: 'Efficiently manage and track all your loans',
      borrowerTracking: 'Keep detailed records of all borrowers',
      collateralManagement: 'Track and manage pledged collateral',
      profitabilityAnalysis: 'Analyze your business profitability',
      advancedAnalytics: 'Get insights with powerful analytics',
      secureReliable: 'Your data is safe and secure'
    },
    logoutSuccess: 'Logged out successfully!',
    sessionExpired: 'Your session has expired. Please login again.',
    businessSetup: 'Business Setup',
    businessName: 'Business Name',
    contactNumber: 'Contact Number',
    address: 'Address',
    businessEmail: 'Business Email (Optional)',
    continue: 'Continue',
    backToSignUp: 'Back to Sign Up'
  },

  // Borrowers Page
  borrowers: {
    title: 'Borrowers',
    listTitle: 'All Borrowers',
    createNewBorrower: 'Create New Borrower',
    searchPlaceholder: 'Search borrowers...',
    searchPlaceholderTable: 'Search by name or phone',
    addBorrower: 'Add Borrower',
    name: 'Name',
    phone: 'Phone',
    email: 'Email',
    address: 'Address',
    activeLoans: 'Active Loans',
    totalBorrowed: 'Total Borrowed',
    viewDetails: 'View Details',
    noBorrowersFound: 'No borrowers found',
    loadingBorrowers: 'Loading borrowers...',
    tableHeaders: {
      index: '#',
      name: 'NAME',
      fatherName: 'F/D/W OF',
      phone: 'PHONE',
      email: 'EMAIL',
      address: 'ADDRESS',
      idProofType: 'ID PROOF TYPE',
      idNumber: 'ID NUMBER',
      viewId: 'VIEW ID',
      actions: 'ACTIONS'
    },
    tooltips: {
      viewId: 'View ID Proof',
      edit: 'Edit borrower',
      delete: 'Delete borrower'
    },
    tableLabels: {
      noProof: 'N/A'
    },
    pagination: {
      label: 'Page',
      of: 'of',
      prev: 'Prev',
      next: 'Next'
    },
    deleteModal: {
      title: 'Confirm Delete',
      messageStart: 'Are you sure to delete',
      cancel: 'Cancel',
      confirm: 'Delete'
    },
    editModal: {
      title: 'Edit Borrower',
      close: 'Close'
    },
    form: {
      fullNameLabel: 'Full Name *',
      fatherNameLabel: 'Father/Husband/Dependent Name *',
      contactNumberLabel: 'Contact Number *',
      idProofTypeLabel: 'ID Proof Type *',
      selectIdProofType: 'Select ID Proof Type',
      idProofNumberLabel: 'ID Proof Number *',
      emailLabel: 'Email',
      addressLabel: 'Address *',
      uploadTitle: 'ID Proof Photos (Max 2)',
      currentPhotosTitle: 'Current Photos:',
      uploadHint: 'Click to upload new photos',
      uploadLimit: 'JPEG, PNG (Max 5MB each)',
      newPhotoLabel: 'New',
      removePhoto: 'Remove photo'
    },
    upload: {
      maxPhotosError: 'Maximum 2 photos allowed',
      invalidFileType: 'Please select valid image files (JPEG, PNG)',
      fileTooLarge: 'Maximum size is 5MB per image',
      success: 'Images uploaded successfully!',
      failure: 'Image upload failed',
      selectedSuffix: 'new photo(s) selected'
    },
    buttons: {
      cancel: 'Cancel',
      update: 'Update Borrower'
    },
    status: {
      uploading: 'Uploading...'
    },
    toast: {
      updateSuccess: 'Borrower updated successfully',
      updateError: 'Failed to update borrower',
      deleteSuccess: 'Borrower deleted successfully',
      deleteError: 'Failed to delete borrower',
      loadError: 'Failed to load borrowers'
    },
    imageModal: {
      noImages: 'No proof images available',
      failedToLoad: 'Failed to load image'
    }
  },

  // Loans Page
  loans: {
    title: 'All Loans',
    loanId: 'Loan ID',
    borrowerName: 'Borrower Name',
    amount: 'Amount',
    interestRate: 'Interest Rate',
    startDate: 'Start Date',
    endDate: 'End Date',
    status: 'Status',
    actions: 'Actions',
    active: 'Active',
    closed: 'Closed',
    overdue: 'Overdue',
    viewDetails: 'View Details',
    noLoansFound: 'No loans found',
    searchPlaceholder: 'Search loans...',
    filterByStatus: 'Filter by Status',
    allLoans: 'All Loans',
    searchByLoanPlaceholder: 'Search by Loan Number or Customer',
    serialSearchPlaceholder: 'Search by Serial Number',
    dateFilterLabel: 'Date',
    dateFieldLabel: 'Date',
    allStatus: 'All Status',
    filterAction: 'Filter',
    resetAction: 'Reset',
    todayLabel: 'Today',
    dateFilterOptions: {
      all: 'All dates',
      date: 'Single Date',
      month: 'By Month',
      year: 'By Year',
      range: 'Date Range'
    },
    dateTips: {
      single: 'Select a date to filter loans for that day.',
      range: 'Select a start and end date to filter loans in that range.',
      month: 'Choose a month to filter loans created in that month.',
      year: 'Choose a year to filter loans created in that year.'
    },
    fromDateLabel: 'From',
    toDateLabel: 'To',
    clearDateFilter: 'Clear',
    closeDateFilter: 'Close',
    statusFilterLabel: 'Status',
    collateralFilterLabel: 'Collateral',
    statusOptions: {
      all: 'All',
      awaited: 'Awaited',
      active: 'Active',
      completed: 'Completed'
    },
    collateralStatusOptions: {
      all: 'All',
      inHand: 'In hand',
      pledged: 'Pledged',
      awaiting: 'Awaiting',
      handover: 'Handover'
    },
    tableHeaders: {
      loanId: 'LOAN ID',
      serialNumber: 'SERIAL NUMBER',
      customer: 'CUSTOMER',
      relation: 'F/D/W OF',
      contactNumber: 'CONTACT NUMBER',
      principal: 'PRINCIPAL (₹)',
      status: 'STATUS',
      collateralStatus: 'COLLATERAL STATUS',
      packetPlace: 'PACKET PLACE',
      created: 'CREATED',
      actions: 'ACTIONS'
    },
    loadingMessage: 'Loading loans...',
    emptyFiltered: 'No loans found matching your criteria',
    toast: {
      deleteSuccess: 'Loan deleted successfully',
      deleteError: 'Failed to delete loan'
    },
    messages: {
      loadError: 'Failed to load loans',
      searchMinChars: 'Enter at least 2 characters to search'
    },
    deleteModal: {
      title: 'Confirm Delete',
      messageStart: 'Are you sure you want to delete the loan for',
      warning: 'This will also permanently remove all related pledge records and payment details.',
      cancel: 'Cancel',
      confirm: 'Delete'
    },
    tooltips: {
      delete: 'Delete loan'
    },
    statusLabels: {
      awaited: 'Awaited',
      active: 'Active',
      completed: 'Completed',
      default: 'Awaited'
    },
    collateralStatusLabels: {
      inHand: 'In hand',
      pledged: 'Pledged',
      awaiting: 'Awaiting',
      handover: 'Handover',
      default: 'N/A'
    },
    labels: {
      serialMissing: '-',
      na: 'N/A'
    }
  },

  // Profile Page
  // Support Page
  support: {
    title: 'Support',
    getHelp: 'Get Help',
    contactUs: 'Contact Us',
    email: 'Email',
    phone: 'Phone',
    businessHours: 'Business Hours',
    mondayToFriday: 'Monday to Friday: 9:00 AM - 6:00 PM',
    faq: 'Frequently Asked Questions',
    sendMessage: 'Send Message',
    yourMessage: 'Your Message',
    messageSent: 'Message sent successfully'
  },

  // Profitability Page
  profitability: {
    title: 'Profitability',
    purpose: 'How much money did my business actually make?',
    businessSummary: 'Business Summary',
    summaryLastMonth: 'last month',
    summaryLastQuarter: 'last quarter',
    summaryLastYear: 'last year',
    summaryPriorPeriod: 'the prior period',
    summaryProfitIncreased: 'Profit increased {percent}% compared to {period}.',
    summaryProfitDecreased: 'Profit decreased {percent}% compared to {period}.',
    summaryProfitUnchanged: 'Profit is unchanged compared to {period}.',
    summaryNetProfit: 'Net Profit this period is {amount}.',
    summaryOutstandingInterest: 'Outstanding Interest is {amount}.',
    summaryHighestMonth: 'Highest earning month is {month} ({amount}).',
    thisMonth: 'This Month',
    thisQuarter: 'This Quarter',
    thisYear: 'This Year',
    allTime: 'All',
    grossIncome: 'Gross Income',
    totalExpenses: 'Total Expenses (Bank Interest Paid)',
    netProfit: 'Net Profit',
    netLoss: 'Net Loss',
    fromLastMonth: 'from last month',
    fromLastQuarter: 'from last quarter',
    fromLastYear: 'from last year',
    fromPriorPeriod: 'vs prior period',
    interestEarned: 'Interest Earned',
    pledgeInterestPaid: 'Bank Interest Paid',
    bankInterestPaid: 'Bank Interest Paid',
    profitMargin: 'Profit Margin %',
    month: 'Month',
    financialPosition: 'Financial Position',
    moneyWithCustomers: 'Money with Customers',
    moneyBorrowedFromBank: 'Money Borrowed from Bank',
    ownCapitalInvested: 'Own Capital Invested',
    outstandingInterestYetToCollect: 'Outstanding Interest Yet to Collect',
    profitInsights: 'Profit Insights',
    highestProfitMonth: 'Highest Profit Month',
    lowestProfitMonth: 'Lowest Profit Month',
    averageMonthlyProfit: 'Average Monthly Profit',
    totalProfitSelected: 'Total Profit (Selected Period)',
    monthlyFinancialTable: 'Monthly Financial Table',
    monthlyRevenue: 'Monthly Revenue',
    viewReport: 'View Report',
    monthlyProfitabilityTrend: 'Monthly Profitability Trend',
    monthlyBreakdownOverview: 'Monthly Breakdown Overview',
    noChartData: 'No chart data available for the selected period'
  },

  // Analytics Page
  analytics: {
    title: 'Analytics',
    purpose: 'How healthy and efficiently is my business performing?',
    businessSummary: 'Business Summary',
    businessPerformance: 'Business Performance',
    portfolioHealth: 'Portfolio Health',
    riskLow: 'Low',
    riskMedium: 'Medium',
    riskHigh: 'High',
    summaryCollectionRate: 'Collection Rate is {percent}%.',
    summaryPortfolioRisk: 'Portfolio Risk is {level}.',
    summaryOverdueOne: '{count} loan is overdue.',
    summaryOverdueMany: '{count} loans are overdue.',
    summaryActivePortfolio: 'Active Portfolio Value is {amount}.',
    summaryLoanGrowthUp: 'Loan growth increased {percent}% compared to the previous period.',
    summaryLoanGrowthDown: 'Loan growth decreased {percent}% compared to the previous period.',
    summaryLoanGrowthFlat: 'Loan growth is unchanged compared to the previous period.',
    overview: 'Overview',
    loanTrends: 'Loan Trends',
    borrowerActivity: 'Borrower Activity',
    revenueAnalysis: 'Revenue Analysis',
    monthlyComparison: 'Monthly Comparison',
    last7Days: 'Last 7 Days',
    last30Days: 'Last 30 Days',
    last90Days: 'Last 90 Days',
    lastYear: 'Last Year',
    exportReport: 'Export Report',
    loanGrowth: 'Loan Growth',
    activePortfolioValue: 'Active Portfolio Value',
    collectionRate: 'Collection Rate',
    riskScore: 'Risk Score',
    portfolioSummary: 'Portfolio Summary',
    activeLoans: 'Active Loans',
    completedLoans: 'Completed Loans',
    overdueLoans: 'Overdue Loans',
    outstandingPrincipal: 'Outstanding Principal',
    collectionPerformance: 'Collection Performance',
    collections: 'Collections',
    recoveryRate: 'Recovery Rate',
    latePayments: 'Late Payments',
    customerInsights: 'Customer Insights',
    newCustomers: 'New Customers',
    repeatCustomers: 'Repeat Customers',
    averageLoanSize: 'Average Loan Size',
    loanStatusDistribution: 'Loan Status Distribution',
    awaited: 'Awaited',
    active: 'Active',
    completed: 'Completed'
  },

  // Create Pledge / Re-pledging Page
  createPledge: {
    title: 'Create New Re-pledging',
    backToCollateral: 'Back to Re-pledging',
    loanId: 'Loan Number',
    loanNumber: 'Loan Number',
    loanIdPlaceholder: 'Search by loan number, customer name, or phone...',
    selectedLoan: 'Selected Loan',
    borrower: 'Borrower',
    phone: 'Phone',
    amount: 'Amount',
    serialNumber: 'Serial Number',
    pledgedTo: 'Pledged To',
    pledgedToPlaceholder: 'Bank or institution name',
    searchBank: 'Search bank...',
    selectOrType: 'Select from list or type a new name',
    pledgeAmount: 'Pledge Amount (₹)',
    pledgeAmountPlaceholder: 'Enter pledge amount',
    interestRate: 'Interest Rate (% per month)',
    interestRatePlaceholder: 'Interest rate',
    pledgeDate: 'Pledge Date',
    searchingLoans: 'Searching loans...',
    noLoansFound: 'No loans found',
    maturityDate: 'Maturity Date',
    uploadDocument: 'Upload Document',
    uploadDocumentHint: 'Upload pledge document (optional)',
    clickToUpload: 'Click to upload',
    or: 'or',
    dragDrop: 'Drag and drop here',
    supportedFormats: 'PDF, PNG, JPG, JPEG (max 10MB)',
    documentPreview: 'Document Preview',
    buttons: {
      save: 'Save',
      creating: 'Saving...',
      uploading: 'Uploading...',
      createPledge: 'Create Pledge'
    },
    messages: {
      selectLoan: 'Please select a loan',
      fillAllFields: 'Please fill all required fields',
      pledgeCreatedSuccess: 'Pledge created successfully!',
      uploadFailed: 'Document upload failed. Please try again.',
      createFailed: 'Failed to create pledge',
      alreadyPledged: 'The item is already pledged'
    }
  },

  // Collateral/Re-pledging Page
  collateral: {
    title: 'Re-pledging',
    listTitle: 'All Pledges',
    createNewPledge: 'Create New Pledge',
    bankSummary: {
      button: 'Bank Summary',
      title: 'Bank Summary',
      subtitle: 'Overview of your re-pledged loans by bank',
      loading: 'Loading bank summary...',
      loadError: 'Failed to load bank summary',
      retry: 'Retry',
      emptyTitle: 'No pledged loans found',
      emptyMessage: 'There are currently no re-pledged loans to summarize.',
      perMonth: 'per month',
      pledgedLoans: 'Pledged Loans',
      pledgedAmount: 'Pledged Amount',
      interestPaid: 'Interest Paid',
      interestDue: 'Interest Due',
      viewLoans: 'View {count} Loans →',
      totalSummary: 'Total Summary',
      activeTotalSummary: 'Active at Bank',
      activeTotalHint: 'PLEDGED + AWAITING only',
      allTimeTotalSummary: 'All-time Total',
      allTimeTotalHint: 'HISTORY',
      loansBadge: '{count} Loans',
      totalLoans: 'Total Loans',
      totalPledgedAmount: 'Total Pledged Amount',
      totalInterestPaid: 'Total Interest Paid',
      totalInterestDue: 'Total Interest Due'
    },
    pledgeId: 'Pledge ID',
    itemName: 'Item Name',
    weight: 'Weight',
    value: 'Value',
    status: 'Status',
    pledgedDate: 'Pledged Date',
    viewDetails: 'View Details',
    noPledgesFound: 'No pledges found',
    searchPlaceholder: 'Search pledges...',
    searchPlaceholderDetailed: 'Search by borrower, loan ID, or pledged to...',
    filterLabel: 'All Status',
    tableHeaders: {
      loanId: 'LOAN ID',
      loanNo: 'Loan No.',
      serialNo: 'Serial No.',
      borrower: 'BORROWER',
      pledgedTo: 'PLEDGED TO',
      pledgeAmount: 'PLEDGE AMOUNT',
      interestRate: 'INTEREST RATE',
      pledgeDate: 'PLEDGE DATE',
      maturityDate: 'MATURITY DATE',
      status: 'STATUS'
    },
    history: {
      title: 'Pledge History',
      previous: 'previous',
      previousLabel: 'PREVIOUS',
      current: 'CURRENT',
      older: 'OLDER',
      present: 'Present'
    },
    statusOptions: {
      all: 'All Status',
      inHand: 'In hand',
      pledged: 'Pledged',
      awaiting: 'Awaiting',
      handover: 'Handover'
    },
    loadingMessage: 'Loading pledges...',
    emptyState: 'No pledges found',
    errors: {
      noBusinessSelected: 'No business selected',
      loadFailed: 'Failed to load pledges',
      updateFailed: 'Failed to update status',
      interestDue: 'Interest is due. Pay pledge interest before changing status to In Hand.',
      interestDueHandover: 'Interest is due. Pay pledge interest before changing status to Handover.',
      loanDue: 'Cannot update collateral status until the full due amount is paid.',
      statusLocked: 'This pledge is completed and handed over. Status cannot be changed.'
    },
    interestDueModal: {
      title: 'Interest is due',
      loanDueTitle: 'Payment required',
      payNow: 'Pay Interest',
      ok: 'OK'
    },
    statusModal: {
      title: 'Confirm Status Change',
      messageStart: 'Are you sure you want to change the status for',
      from: 'from',
      to: 'to',
      defaultName: 'this pledge',
      cancel: 'Cancel',
      confirm: 'Change Status',
      updating: 'Updating...'
    }
  },

  // Loan Details Page
  loanDetails: {
    loading: 'Loading loan details...',
    notFound: 'Loan not found',
    backToList: 'Back to loans',
    back: 'Back',
    recordPayment: 'Record payment',
    additionalLoan: 'Additional loan',
    additionalAdvance: 'Additional advance',
    roundOff: 'Round-off',
    settlementAdjustment: 'Settlement adjustment',
    paymentAllocation: 'Payment allocation',
    additionalDisbursement: 'Additional disbursement',
    initialDisbursement: 'Initial disbursement',
    payment: 'Payment',
    advanceLedger: 'Loan advances',
    advanceDate: 'Advance date',
    advanceAmount: 'Advance amount',
    maximumEligibleAmount: 'Maximum eligible',
    currentTotalAdvanced: 'Current total advanced',
    currentInterestRate: 'Current interest rate',
    remainingEligibleAmount: 'Remaining eligible',
    outstandingPrincipal: 'Outstanding principal',
    outstandingInterest: 'Outstanding interest',
    noAdvances: 'No advance records found',
    saveAdditionalLoan: 'Add loan',
    addingAdditionalLoan: 'Adding...',
    summaryTitle: 'Loan summary',
    borrowerLabel: 'Borrower',
    principalLabel: 'Loan amount',
    interestLabel: 'Accrued interest',
    durationLabel: 'Loan duration',
    durationUnit: 'months',
    durationSingleUnit: 'month',
    interestRow: 'Interest',
    interestPerMonth: 'per month',
    principalOutstanding: 'Loan amount',
    totalDue: 'Total amount due',
    totalPaid: 'Total paid',
    borrowerCardTitle: 'Borrower details',
    borrowerContact: 'Contact number',
    borrowerEmail: 'Email',
    borrowerAddress: 'Address',
    pledgeCardTitle: 'Re-pledge details',
    pledgeStatus: 'Pledge status',
    pledgedTo: 'Pledged with',
    pledgeDate: 'Pledge date',
    maturityDate: 'Due date',
    collateralStatus: 'Status',
    paymentHistory: 'Payment history',
    paymentTable: {
      noPayments: 'No payments recorded yet',
      headers: {
        date: 'Date',
        amount: 'Amount',
        interest: 'Interest',
        penalty: 'Penalty',
        mode: 'Mode',
        reference: 'Reference',
        notes: 'Notes',
        actions: 'Actions'
      },
      viewReceipt: 'View receipt',
      delete: 'Delete'
    },
    paymentModal: {
      title: 'Add payment',
      amountLabel: 'Amount',
      methodLabel: 'Payment method',
      descriptionLabel: 'Description',
      referenceLabel: 'Reference number',
      close: 'Close',
      save: 'Save payment',
      recording: 'Recording...',
      paymentType: 'Payment type',
      regularPayment: 'Regular payment',
      interestOnly: 'Interest only',
      fullSettlement: 'Full settlement',
      interestAllocation: 'Interest allocation',
      principalAllocation: 'Principal allocation',
      expectedSettlement: 'Expected settlement amount',
      enterDescription: 'Optional note'
    },
    statusModal: {
      title: 'Change pledge status',
      message: 'Mark collateral as returned and close the loan?',
      cancel: 'Cancel',
      confirm: 'Confirm',
      updating: 'Updating...'
    },
    deleteLoanModal: {
      title: 'Delete loan',
      message: 'Are you sure you want to delete this loan? This cannot be undone.',
      confirm: 'Delete loan',
      cancel: 'Cancel'
    },
    deletePaymentModal: {
      title: 'Delete payment',
      message: 'Are you sure you want to delete this payment?',
      confirm: 'Delete payment',
      cancel: 'Cancel'
    },
    messages: {
      loadError: 'Failed to load loan details',
      pledgesLoadError: 'Failed to load pledges',
      paymentsLoadError: 'Failed to load payments',
      statusUpdateSuccess: 'Collateral marked as returned and loan closed.',
      statusUpdateError: 'Failed to update status. Please try again.',
      paymentCreateSuccess: 'Payment added successfully',
      paymentCreateError: 'Failed to add payment',
      paymentDeleteSuccess: 'Payment deleted successfully',
      paymentDeleteError: 'Failed to delete payment',
      paymentAmountInvalid: 'Please enter a valid payment amount',
      missingBusiness: 'Missing business or loan information',
      advanceAmountInvalid: 'Please enter a valid advance amount',
      advanceCreateSuccess: 'Additional loan added successfully',
      advanceCreateError: 'Failed to add additional loan'
    },
    transactionLedger: 'Transaction Ledger (Khata)',
    loadingTransactions: 'Loading transactions...',
    noTransactionsFound: 'No transactions found',
    serialNumber: 'Serial Number',
    itemDetails: 'Item Details',
    metalType: 'Metal Type',
    purity: 'Purity',
    netWeight: 'Net Weight',
    lendingRate: 'Lending Rate per Gram',
    ledgerHeaders: {
      date: 'Date',
      description: 'Description',
      paymentMethod: 'Payment method',
      reference: 'Reference',
      roundOff: 'Round-off',
      amount: 'Amount'
    }
  },

  // Borrower Details Page
  borrowerDetails: {
    loading: 'Loading borrower details...',
    notFound: 'Borrower not found',
    back: 'Back',
    backToList: 'Back to borrowers',
    headerId: 'Borrower ID',
    infoTitle: 'Borrower information',
    labels: {
      fullName: 'Full name',
      fatherName: "Father's name",
      contactNumber: 'Contact number',
      email: 'Email',
      idProofType: 'ID proof type',
      idProofNumber: 'ID proof number',
      address: 'Address',
      createdDate: 'Created date'
    },
    documents: {
      title: 'ID proof documents',
      expand: 'Expand',
      none: 'No ID proof uploaded'
    },
    loans: {
      title: 'Loan history',
      loading: 'Loading loans...',
      empty: 'No loans found for this borrower',
      headers: {
        loanId: 'Loan ID',
        serialNumber: 'Serial number',
        principal: 'Loan amount (₹)',
        interestRate: 'Interest rate',
        tenure: 'Tenure',
        status: 'Status',
        createdDate: 'Created date',
        actions: 'Actions'
      },
      perMonth: 'per month',
      months: 'months',
      view: 'View details'
    },
    messages: {
      loadError: 'Failed to load borrower details',
      loansError: 'Failed to load borrower loans'
    },
    modal: {
      close: 'Close',
      previous: 'Previous',
      next: 'Next'
    }
  },

  // Pledge Details Page
  pledgeDetails: {
    loading: 'Loading re-pledge details...',
    notFound: 'Re-pledge not found',
    back: 'Back',
    backToList: 'Back to re-pledges',
    statusBadge: 'Status',
    summaryTitle: 'Re-pledge summary',
    currentBadge: 'CURRENT',
    previousBadge: 'PREVIOUS',
    olderBadge: 'OLDER',
    presentLabel: 'Present',
    pledgeHistoryTitle: 'Pledge History',
    loanCollateralStatus: 'Loan Status',
    borrowerTitle: 'Borrower details',
    loanTitle: 'Linked loan',
    pledgedAmount: 'Pledge amount',
    interestRate: 'Interest rate',
    pledgeDate: 'Pledge date',
    maturityDate: 'Due date',
    pledgedTo: 'Pledged with',
    interestEarned: 'Interest earned',
    totalDue: 'Total amount due',
    pledgeDuration: 'Pledge duration',
    interestBreakdownTitle: 'Interest breakdown',
    additionalDaysLabel: 'days',
    netProfit: 'Net monthly profit',
    updateStatus: 'Mark as returned',
    currentInterestTitle: 'Current Interest',
    interestPeriod: 'Period',
    interestDuration: 'Duration',
    interestDue: 'Interest Due',
    interestPaid: 'Interest Paid',
    interestOutstanding: 'Outstanding',
    interestStatus: 'Status',
    interestStatusPaid: 'PAID',
    interestStatusUnpaid: 'UNPAID',
    payInterest: 'Pay Interest',
    interestHistoryTitle: 'Interest Payment History',
    interestHistoryDate: 'Date',
    interestHistoryPeriod: 'Period',
    interestHistoryDays: 'Days',
    interestHistoryAmount: 'Amount',
    interestHistoryStatus: 'Status',
    days: 'days',
    interestPayModal: {
      title: 'Pay pledge interest',
      message: 'Confirm payment of {amount} for the current interest period.',
      cancel: 'Cancel',
      confirm: 'Pay Interest',
      paying: 'Paying...'
    },
    statusModal: {
      title: 'Mark as returned',
      message: 'Has the pledged item been returned to the borrower?',
      cancel: 'Cancel',
      confirm: 'Yes, mark returned',
      updating: 'Updating...'
    },
    messages: {
      loadError: 'Failed to load pledge details',
      loanLoadError: 'Failed to load linked loan',
      statusSuccess: 'Pledge marked as returned and loan closed.',
      statusError: 'Failed to update status. Please try again.',
      noBusiness: 'No business selected',
      noRecords: 'No re-pledge records',
      interestPaySuccess: 'Pledge interest paid successfully.',
      interestPayError: 'Failed to pay pledge interest. Please try again.'
    }
  },
  
  // SEO Keywords and Content
  seo: {
    // Primary Keywords
    primaryKeywords: [
      'gold loan management software',
      'jewelry loan system',
      'silver loan software',
      'loan against gold',
      'gold lending software',
      'pledge loan management',
      'collateral loan software',
      'pawn shop software',
      'gold loan business software',
      'ornament loan management'
    ],
    
    // Secondary Keywords
    secondaryKeywords: [
      'gold loan calculator',
      'jewelry finance software',
      'loan management system India',
      'gold loan Rajasthan',
      'sahukaar software',
      'gold rate calculator',
      'interest calculator for loans',
      'customer loan tracking',
      'borrower management system',
      'loan repayment tracker',
      'gold purity calculator',
      '22 carat gold loan',
      '24 carat gold loan',
      '18 carat gold loan',
      'hallmark gold loan',
      'Indian gold loan software',
      'Bharat gold loan',
      'small business loan software',
      'MSME loan management',
      'microfinance software',
      're-pledging software',
      'loan book software',
      'khata book for loans',
      'digital loan management',
      'online gold loan',
      'gold shop software',
      'jewelry store loan system'
    ],
    
    // Location-Based Keywords
    locationKeywords: [
      'gold loan Jaipur',
      'gold loan Jodhpur',
      'gold loan Rajasthan',
      'gold loan Delhi',
      'gold loan Mumbai',
      'gold loan India',
      'Rajasthani business software',
      'Marwari business software'
    ],
    
    // Long-Tail Keywords
    longTailKeywords: [
      'how to manage gold loan business',
      'best gold loan management software',
      'software for jewelry loan business',
      'digital solution for gold lending',
      'track gold loan customers',
      'manage pledge loans online',
      'gold loan interest calculator',
      'software for sahukaar business',
      'loan management for small business',
      'gold collateral management system'
    ],
    
    // Meta Descriptions
    metaDescriptions: {
      home: 'Complete Gold & Silver Loan Management Software. Manage gold loans, jewelry loans, pledge loans, and collateral with ease. Perfect for gold loan businesses, pawn shops, and jewelry finance companies.',
      features: 'Track loans, manage borrowers, handle collateral, calculate interest, generate reports, and grow your gold loan business with our comprehensive management software.',
      benefits: 'Streamline your gold loan business operations with automated calculations, customer tracking, payment management, and detailed analytics. Trusted by businesses across India.'
    },
    
    // Page Titles
    pageTitles: {
      home: 'Gold Loan Management Software | Jewelry Loan System | Best Loan Management Solution',
      dashboard: 'Loan Dashboard | Track Gold Loans, Customers & Payments',
      loans: 'Manage Gold Loans | Jewelry Loan Tracking | Loan Management',
      borrowers: 'Customer Management | Borrower Tracking | Gold Loan Customers',
      collateral: 'Collateral Management | Pledge Tracking | Re-pledging System',
      analytics: 'Loan Analytics | Business Reports | Profitability Analysis',
      settings: 'Gold Rate Settings | Interest Rates | Loan Configuration'
    }
  },

  profile: {
    businessProfile: 'Business Profile',
    editBusinessProfile: 'Edit Business Profile',
    businessName: 'Business Name',
    contactNumber: 'Contact Number',
    businessAddress: 'Business Address',
    noLogo: 'No Logo',
    uploading: 'Uploading...',
    change: 'Change',
    upload: 'Upload',
    imageFormat: 'PNG, JPG up to 5MB',
    cancel: 'Cancel',
    saveBusinessProfile: 'Save Business Profile',
    saving: 'Saving...',
    
    userProfile: 'User Profile',
    editProfile: 'Edit Profile and Change Password',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    role: 'Role',
    previousPassword: 'Previous Password',
    newPassword: 'New Password',
    enterCurrentPassword: 'Enter your current password',
    enterNewPassword: 'Enter your new password',
    saveChanges: 'Save Changes',
    
    logout: 'Logout',
    
    errors: {
      invalidImage: 'Please select a valid image file.',
      imageSizeLimit: 'Image size must be less than 5MB.',
      uploadFailed: 'Failed to upload logo',
      businessIdNotFound: 'Business ID not found. Please try refreshing the page.',
      contactRequired: 'Contact Number is required.',
      addressRequired: 'Business Address is required.',
      updateBusinessFailed: 'Failed to update business profile. Please try again.',
      updateBusinessError: 'An error occurred while updating business profile. Please try again.',
      userIdNotFound: 'User ID not found. Please try logging in again.',
      passwordFieldsRequired: 'Both previous password and new password are required to change password.',
      passwordMinLength: 'New password must be at least 6 characters long.',
      updateProfileFailed: 'Failed to update profile. Please try again.',
      updateProfileError: 'An error occurred while updating profile. Please try again.'
    }
  }
};
